module.exports = __webpack_public_path__ + "img/arrow-customize-builder.bedfd332.svg";